import { HttpLink } from 'apollo-angular-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloLink, concat } from 'apollo-link'
import { HttpHeaders } from '@angular/common/http';

import { APOLLO_OPTIONS } from 'apollo-angular'

import { ConfigService } from './config.service'
import { StatusService } from './status.service'

export function createApollo(
  httpLink: HttpLink,
  config: ConfigService,
  status: StatusService
) {

  console.log('createApollo', config.CONFIG)

  const uri = config.CONFIG.graphql_endpoint

  const http = httpLink.create({ uri })

  const authMiddleware = new ApolloLink((operation, forward) => {

    const accessToken = status.getAccessToken()

    if(accessToken) {
      operation.setContext({
        headers: new HttpHeaders().set('Authorization', `Bearer ${accessToken}`)
      });
    }

    return forward(operation);
  });

  const defaultOptions = {
    watchQuery: {
      fetchPolicy: 'network-only'
    },
    query: {
      fetchPolicy: 'network-only'
    },
  }

  return {
    link: concat(authMiddleware, http),
    cache: new InMemoryCache(),
    defaultOptions
  }
}

export const GraphqlProvider = {
  provide: APOLLO_OPTIONS,
  useFactory: createApollo,
  deps: [
    HttpLink,
    ConfigService,
    StatusService
  ],
}
